// src/pages/salary/components/Mo3tiProgressBar.jsx

const Mo3tiProgressBar = ({ percentage, color, theme }) => (
  <div style={{ width: '100%', height: '8px', background: theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', borderRadius: '4px', overflow: 'hidden', marginTop: '8px' }}>
    <div style={{ width: `${percentage}%`, height: '100%', background: color, transition: 'width 0.3s ease' }} />
  </div>
);

export default Mo3tiProgressBar;